import { render } from "./sidebar-app.vue?vue&type=template&id=5ccba33a&scoped=true&ts=true"
import script from "./sidebar-app.vue?vue&type=script&lang=ts"
export * from "./sidebar-app.vue?vue&type=script&lang=ts"

import "./sidebar-app.vue?vue&type=style&index=0&id=5ccba33a&lang=css"
import "./sidebar-app.scss?vue&type=style&index=1&id=5ccba33a&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccba33a"]])

export default __exports__